module.exports = __webpack_public_path__ + "img/1.d48b977b.png";